<ct-lib-floating-shape [scale]="screenService.isMobile ? 4 : 2" style="bottom: -50vh; left: -50vw;"></ct-lib-floating-shape>
<ct-lib-floating-shape [scale]="screenService.isMobile ? 4 : 2" style="top: -50vh; right: -40vw;" @fadeInOut></ct-lib-floating-shape>

<div class="view-content" #confettiTrigger>
  @if (state === 'success') {
    <div class="ct-card verify-success">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 819 810" style="enable-background:new 0 0 819 810;" xml:space="preserve">
        <style type="text/css">
          .st1{clip-path:url(#SVGID_00000130630634182842470390000015588711369902838678_);}
          .st2{fill:#2A343C;}
          .st3{fill:#32424A;}
          .st4{fill:#FF928A;}
          .st5{fill:#EDF4FB;}
          .st6{fill:#15839F;}
          .st7{fill:#D1D1D1;}
          .st8{fill:#807E7E;}
          .st9{fill:#80B07D;}
          .st10{fill:#FFFFFF;}
          .st11{fill:#E73B3D;}
          .st12{fill:#8DCFDE;}
          .st13{fill:#ED8A44;}
          .st14{fill:#70B54D;}
          .st15{fill:#399FB7;}
        </style>
        <g id="Template">
        </g>
        <g id="Capa_3">
      <path class="st0" [style]="'fill: ' + correctedBackgroundColor" d="M498.7,786.8c62.7-12.9,123.4-37.5,175.2-71.3c162-105.7,165.6-343.9,86.2-501.6c-2.5-5-5.1-10-7.9-14.8
        C690.7,88.3,563.1,34,442.2,68.9c-61.9,17.8-122.7,46.6-165.5,94.8c-51.1,57.5-71.9,137-122.2,195.3c-21.9,25.4-48.9,46.1-70,72.2
        c-26.5,32.7-42.9,73.4-46.5,115.3c-9.3,108.1,105.1,185.5,193.5,218.2C316,795.9,410.6,805,498.7,786.8z"/>
          <image style="overflow:visible;" width="1336" height="477" xlink:href="5D1E45AA.jpg"  transform="matrix(1 0 0 1 -14162.1611 -8602.7344)">
          </image>
          <g>
            <defs>
          <path id="SVGID_1_" d="M818.8,388.5c0,39-5.5,78.1-16.5,115.5c-13.7,46.6-35.8,90.6-64.9,129.5c-14.4,19.2-30.4,37.2-48,53.6
            c-18,16.9-40,29.9-56.4,48c-3.3,3.6-6.5,7.2-10.4,10.1c-5,3.7-10.9,6.1-16.7,8.3c-6.2,2.4-12.4,4.8-18.7,7.1
            c-57.6,21.2-115.9,37.1-177.7,37.1c-226,0-409.2-183.2-409.2-409.2S183.5-20.8,409.5-20.8S818.8,162.5,818.8,388.5z"/>
            </defs>
            <clipPath id="SVGID_00000021842125271111864430000015084457460850680982_">
              <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
            </clipPath>
            <g style="clip-path:url(#SVGID_00000021842125271111864430000015084457460850680982_);">
          <path class="st2" d="M421,660.9c0.3-0.9,0.8-1.9,1.6-2.5c0.9-0.6,2-0.5,3.1-0.4c13.9,1.7,26.9,7.3,39.7,12.8
            c14.4,6.2,29.7,13.2,37.8,26.6c10.8,17.8,3.6,37.1,2.4,56.1c-0.4,5.5-8.5,65.6-9.2,65.4c-3.2-1.1-6.7-0.9-10-0.7
            c-25,1.7-49.7,7.5-74.7,6.4c-1.5-0.1-3.1-0.2-4.2-1.2c-1.6-1.4-1.6-3.7-1.5-5.8c1.3-28.2,2.6-56.4,3.9-84.6
            C411,708.1,412.1,684.6,421,660.9z"/>
          <path class="st2" d="M601,667.5c-0.4-0.9-0.8-1.9-1.8-2.5c-1-0.6-2.3-0.5-3.5-0.4c-15.5,1.7-30.1,7.3-44.5,12.8
            c-16.1,6.2-33.2,13.2-42.4,26.6c-10.2,14.9-7.7,34.1-1.8,50.7c0,3.8,4.6,9.6,6.1,13.3c2.9,7.4,4.7,15.4,7,23c0.3,1,0.6,2,1.4,2.7
            c0.9,0.7,2.1,0.9,3.2,0.9c30.4,2.2,60.4-8,90.8-7.4C613.5,747.7,616.6,704.7,601,667.5z"/>
          <path class="st3" d="M454.7,235.9c-4.1-1.5-6.4-6-4.9-10.1c1-2.6,2.8-4.9,5.3-6.2c2.2-1.2,4.9-1.6,6.8-3.2
            c3.9-3.3,2.9-9.5,2.9-14.6c0-4.5,1.3-9.2,4.3-12.6c3-3.4,7.8-5.3,12.2-4.1c2.7,0.8,5.6,2.7,8.2,1.5c2.5-1.2,2.8-4.5,3.8-7.2
            c2.1-5.8,9.2-9.2,15.1-7.2c3.8,1.3,6.7,4.4,10.1,6.6c3.4,2.2,8.3,3.2,11.2,0.4c1.1-1.1,1.8-2.6,2.6-3.9
            c3.6-5.4,11.3-7.3,17.3-4.8c6,2.4,10.2,8.4,11.4,14.8c1,5.5,4.6,12.2,9.5,15s10.6,7.1,9.1,12.5c-1.1,3.9-5.7,6.4-5.9,10.4
            c-0.2,3.9,3.7,6.6,6.9,9c3.1,2.4,6,7,3.4,9.9c-1.8,2.1-5.2,1.9-7.1,3.9c-3.6,3.7,1,11.2-2.8,14.8c-1,0.9-2.4,1.3-3.5,2.2
            c-3,2.4-2.2,7.1-1.7,11c1.6,11.7-2.8,24.1-11.5,32.1c-1.1,1-2.3,2-3.8,2.5c-3,0.9-6-0.6-8.9-1.7c-14.2-5.4-30.1-0.3-43.7,6.3
            c-2.6,1.3-5.9,2.6-8.3,1c-1.2-0.8-1.9-2-2.4-3.3c-2.4-5.2-3.1-11.1-5.5-16.2c-2.4-5.2-6.3-10.3-11.9-9.5
            c1.1-9.8-0.3-21.6-9.1-26.1c-2.8-1.4-6.6-2.4-7-5.4c-0.4-3.2,3.4-5.1,4.9-7.9C463.5,242.4,459,237.5,454.7,235.9z"/>
          <path class="st4" d="M495.3,350.2c1.3-4.4,3.8-7.7,9.9-8.1c6.5-0.5,13-0.9,19.4-1.4c2.4-0.2,4.9-0.3,7,0.9
            c9.9,5.9,8.1,24.7,12,34c2,4.9,5.4,9.1,8.7,13.3c1.4,1.7,2.8,3.5,4.6,4.7c3,2.1,6.8,2.6,10.4,3.6c6.6,1.9,13.8,6,16.2,12.9
            c1.3,3.8,0.3,7.9-0.6,11.7c-2.9,11.2-6.2,22.2-9.8,33.2c-1.2,3.7-2.6,7.6-5.5,10.3c-2.9,2.6-6.9,3.6-10.7,4.5
            c-34.6,7.5-73.8,7.2-102-14.3c-3.5-2.6-6.8-5.7-8.6-9.7c-1.6-3.6-1.7-7.6-1.9-11.6c-0.2-7.2-0.4-14.4-0.7-21.6
            c-0.3-9,3.8-15.2,10.2-21c7.1-6.5,16.5-6.1,24.9-10c6.5-3,11.6-8.9,13.6-15.8C494,360.9,493.9,354.9,495.3,350.2z"/>
          <path class="st5" d="M512.8,452.3c7.7-1.2,14.8-4.9,21.4-9.1c12.4-7.9,23.6-17.8,32.9-29.3c0.3,5.7-2.5,11.1-4.9,16.2
            c-15.4,32.1-22.8,69.7-11.6,103.5c2.3,6.9,5.4,13.7,9.8,19.5c2.8,3.8,6.1,7.1,8.9,10.9c3.5,4.7,6,10,8.6,15.3
            c8.9,18.4,18,37,21.4,57.2c2,11.7,2,23.7,5.6,35c3.7,11.5,11.2,22.5,9.5,34.4c-15.4,9.1-34.1,10-52,10.6
            c-22.8,0.7-46.2,1.1-67.9-5.9c-27.3-8.8-49.4-28.5-70.8-47.6c-1.7-1.5-3.5-3.2-4.4-5.3c-1.4-3.1-0.8-6.7,0-10
            c3.3-14.7,8.5-28.9,11.3-43.7c5.5-29.1,1.6-59.1,2.7-88.7c1.4-37.5,9.7-76.1,20.7-112C464.2,422.2,487.9,456.3,512.8,452.3z"/>
          <path class="st4" d="M538.7,360.6c0-2.4,13.2-14.4,15.2-17.9c3.8-7.2,3.8-14.1,5.5-21.8c3.3-0.7,6.7-1.2,9.3-3.4
            c4.1-3.3,9.8-10.3,9.2-15.9c-0.3-2.7-2.1-5.1-4.6-6.1c-2.5-1-5.5-0.5-7.5,1.2c0-4.7,0.8-8.7-2.3-12.6c-1.6-2.1-3.7-4-4.6-6.4
            c-1.2-2.9-0.7-6.3-1.4-9.4c-0.6-2.8-2.2-5.3-4.5-7c-3.5-2.8-8.3-3.5-12.3-5.4c-5.2-2.6-10-7.5-15.8-6.8c-2.7,0.4-5.2,2-7.8,2.7
            c-5.2,1.3-11-1.2-16,0.8c-3.8,1.5-6.1,5.2-9.2,7.9c-5.3,4.7-13.4,6.7-16.1,13.3c-1.5,3.7-1.5,7.8-2.9,11.5
            c-1.4,3.7-2.4,7.6-3.4,11.5c0.5-2.6-2-5.1-4.7-5.2c-2.6-0.1-5.1,1.7-6.4,4c-2.9,4.8-1.4,11.4,2.1,15.7c3.6,4.4,8.8,7,14,9.2
            c1,0.4,2,0.8,2.6,1.6c0.7,0.8,0.8,2,1,3c1.1,6.5,3.8,12.7,7.7,17.9c9.1,11.9,17.6,24.5,32.6,25.1c3,0.1,6-0.1,8.9-0.9
            C531.6,365.8,535.3,363.3,538.7,360.6z"/>
          <path class="st6" [style]="'fill: ' + colorService.accent" d="M466.3,453.1c0.2,12,0.4,24,0.4,36c0.2,59.5-3.1,118.9-9.9,178c-13.2-3.1-25.7-9.7-35.7-18.8
            c-1.5-1.3-2.9-2.8-3.5-4.7c-0.6-2-0.1-4.1,0.3-6.1c3.3-15,5.6-30.1,6.8-45.4c0.7-8.6,1-17.5-1.5-25.8c-1.8-5.8-4.8-11.2-7-16.9
            c-5.7-15.2-4.6-32-3.3-48.1c-5.3,21.6-12.2,42.8-20.8,63.4c-2.7,6.6-6.1,13.7-12.6,16.7c-6,2.9-13.1,1.5-19.5-0.4
            c-12.4-3.6-25.1-9.3-32.2-20c-7.1-10.8-5.9-27.7,5.3-34.1c2.8-1.6,6-2.5,8.4-4.6c2.5-2.2,3.9-5.4,5-8.6
            c8.4-22.1,14.9-45.3,28.2-64.9c8.8-13,20.3-23.9,31.7-34.8c16.2-15.4,32.6-28.1,55.7-31.3c1-0.1,2.1-0.2,2.8,0.4
            c0.8,0.6,1.1,1.6,1.1,2.6c0.8,12,0,18.5-0.5,33c-0.2,5.5,0.3,11.2,0.3,16.7C465.9,441.3,466.2,447.4,466.3,453.1z"/>
          <path class="st6" [style]="'fill: ' + colorService.accent" d="M567.4,403.1c-19.6,34.4-35.6,71.2-43.7,110c-4.1,19.7-6.2,39.9-5.6,60c0.3,10.1,1.2,20.2,2.8,30.1
            c0.8,5,1.8,9.9,3,14.8c1.1,4.5,3.3,9.3,3.5,13.9c0.3,6.6,3.5,13.4,5.5,19.7c2.3,7.2,4.6,14.4,6.9,21.6
            c9.2-4.1,18.5-8.3,27.7-12.4c2.8-1.2,5.7-2.5,8.7-2.4c7.6,0.3,11.9,8.5,16.4,14.6c4.7,6.3,11.1,11.3,18.3,14.3
            c-4.5-34.5-9.2-69.5-21.7-102c-2.9-7.5-6.2-15.1-6.1-23.2c0.1-7.8,3.4-15.2,6.8-22.3c3.6-7.4,7.3-14.7,11.2-22
            c0.7-1.2,1.4-2.6,2.7-3.2c1.5-0.7,3.2-0.2,4.8,0.4c8.4,3.3,15.1,9.9,22,15.8c14.9,12.9,31.9,23.4,50,31c2.2,0.9,4.7,2,5.7,4.2
            c2.3,4.9-4,9.9-3.8,15.3c9.1,6.5,22,0,32.9,2.8c6.9,1.8,12.3,7.1,17.9,11.5c5.6,4.4,12.8,8.2,19.6,6.3
            c10.5-2.9,13.2-16.7,11.6-27.5c-3.6-23.9-18.3-44.8-35.7-61.5c-17.4-16.7-37.8-30-56.6-45.2c-29.5-23.9-55.8-52.9-90-69.4
            c-3.3-1.6-7.4-3-10.5-1c-1.5,1-2.4,2.6-3.3,4.1C568,402.1,567.7,402.6,567.4,403.1z"/>
          <path class="st4" d="M683.3,586.7c-19.2,16-38,31.1-59.2,44.9c-3.4,2.2-7.6,4.6-11.3,2.9c-2.9-1.3-4.3-4.4-6-7.1
            c-5-7.8-14.6-12.3-23.8-11.3c-7.5,0.8-14.5,5.3-18.6,11.6c-1,1.6,0.5,3.5,2.2,2.9l15.1-5.2c-0.9,10.3-15.6,15.7-15.5,26.1
            c0,0.8,0.1,1.6,0.7,2.1c0.4,0.4,1,0.5,1.5,0.7c6.5,2,10.2,8.8,16.2,12c4.5,2.4,9.8,2.5,14.9,2.6c13.7,0.2,27.8,0.3,40.7-4.4
            c9.6-3.5,18.1-9.4,26.6-15c12.4-8.1,25.2-15.6,38.3-22.5c14.4-7.5,30.1-15.3,37.3-29.8c-13.3-9.9-30-15.4-46.6-15.3
            c-2.4,0-4.9,0.1-7.1,1.1C686.6,584,684.9,585.4,683.3,586.7z"/>
          <path class="st4" d="M433.9,341c-1.1-2.6-3.3-4.8-6-5.8c0.2-6.2-5.6-9.4-10.9-10.5c-2.8-0.6-5.5-0.7-8.4-0.7
            c-0.8,0-1.6-0.1-2.3-0.6c-0.5-0.4-0.7-0.9-1-1.5c-1.2-3-1.4-6.2-1.1-9.4c0.4-5.3,0.8-10.5,1.2-15.8c0.3-4.4-1.2-10.6-5.5-9.9
            c-2.4,0.4-3.7,3.1-4.5,5.4c-2.6,7.9-2.7,17-3.6,25.3c-0.2,2.1,0,5.5-2.6,6.1c-1.9,0.4-4.1-0.5-5.1-2.1c-1.6-2.4-1.5-5.5-1.5-8.4
            c-0.1-6.8-1.6-13.6-4.3-19.8c-1-2.4-4.3-2.5-5.6-0.3c-2.2,3.9-2.4,9.2-1.9,13.9c0.6,5.4,1.7,11.2,0.3,16.3
            c-0.5,1.8-2.8,2.6-4.3,1.3c-2.2-1.9-3.7-5-5.2-7.6c-1.1-2-2.8-4-4.7-5.2c-2.4-1.5-5.6,0.5-5.3,3.4c1.5,15.2,14,28.2,17,43.6
            c2.2,11.3-0.6,23.8-3.8,35.9c-1.7,6.4-3.5,12.6-4.7,18.5c-4.1,19.5-8.2,39.1-12.2,58.6c-2.7,13.1-4.8,26.5-9.3,39
            c-3.1,8.7-7,20.3-1,28.8c3.8,5.4,10.8,7.5,16.6,9.9c3.7,1.6,7.5,2.8,11.5,3.3c19.2,2.1,22.8-12.1,25.1-23.9
            c3.1-15.8,4.9-31.7,5.9-47.8c1.3-22.5,3.4-45,2.3-67.5c-0.5-10-1.3-21.1,4.9-29c4.5-5.8,11.8-8.5,17.6-12.9
            c4.7-3.5,8.5-8.3,10.7-13.7c1.1-2.7,1.7-5.4,1.9-8.3C434.4,346.5,435.2,343.9,433.9,341z M423.8,346.3c-0.9,3.2-3.2,6.2-6.5,7.3
            c-3.7,1.3-7-0.5-9-3.6c-0.8-1.3-1.6-2.8-1.6-4.3c-0.1-3.1,2.2-7.1,5.3-8.1c0.7-0.2,1.4-0.3,2.2-0.3c3.3,0.1,6.4,1.6,9.7,1.7
            C424,339,424,345.6,423.8,346.3z"/>
          <path class="st2" d="M471.1,251.9c1.8-3.1,3.7-6.2,5.9-9c3-4,6.4-7.7,10.2-11c3.2-2.7,6.5-5.2,10.1-7.4c1.7-1,3.5-2,5.4-2.6
            c2.3-0.8,4.7-1,7.1-1.3c3.6-0.4,7.2-0.6,10.8-0.6c11.6,0.2,23.1,4.1,32.4,11c3.9,2.9,7.5,6.4,10.5,10.2c3.1,3.9,5.6,8.1,7.6,12.7
            c0.4,1,0.8,2,1.2,3c0.2,0.4,0.2,0.9,0.4,1.3c0.2,0.6,0.7,1.1,1,1.7c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.6,0.1,0.9-0.1
            c0.1-0.1,0.1-0.2,0.2-0.3c0.5-1.1,0.8-2,0.8-3.1c0-1.1-0.1-2.2-0.2-3.2c-0.2-2-0.4-4.3,0.5-6.2c0.2-0.4,0.5-0.8,0.8-1.2
            c1.9-1.9,5.3-1.8,7.1-3.9c2.6-3-0.3-7.5-3.4-9.9c-3.1-2.4-7.1-5-6.9-9c0.2-4.1,4.9-6.5,5.9-10.4c1.5-5.4-4.2-9.8-9.1-12.5
            s-8.5-9.5-9.5-15c-1.2-6.4-5.3-12.4-11.4-14.8c-6-2.4-13.7-0.6-17.3,4.8c-0.9,1.3-1.5,2.8-2.6,3.9c-2.9,2.8-7.8,1.8-11.2-0.4
            c-3.4-2.2-6.3-5.3-10.1-6.6c-5.8-2-13,1.4-15.1,7.2c-1,2.6-1.3,6-3.8,7.2c-2.6,1.2-5.4-0.7-8.2-1.5c-4.3-1.3-9.2,0.7-12.2,4.1
            c-3,3.4-4.2,8-4.3,12.6c0,5.1,1,11.3-2.9,14.6c-1.9,1.6-4.6,2.1-6.8,3.2c-2.5,1.3-4.3,3.6-5.3,6.2c-1.5,4.1,0.7,8.6,4.9,10.1
            c4.3,1.6,8.7,6.5,6.9,9.7c-1.5,2.8-5.3,4.8-4.9,7.9c0.4,3.1,4.2,4,7,5.4c0.6,0.3,1.2,0.7,1.8,1.1c0.2,0.2,1.1,1.1,1.4,1.1
            c0.2,0,0.2-0.3,0.2-0.5c0.1-1.6,0.8-3.2,1.6-4.6C469.6,254.7,470.3,253.3,471.1,251.9z"/>
            </g>
            <g style="clip-path:url(#SVGID_00000021842125271111864430000015084457460850680982_);">
              <g>
                <g>
              <path class="st7" d="M306.3,292.6c-0.2,0.8-1.1,1.1-1.9,1.3c-50.5,13-101,26.1-152.3,35.4c-1.4,0.2-3,0.4-4-0.6
                c-0.6-0.6-0.7-1.4-0.9-2.3c-4.3-19-7.2-38.4-11.6-57.4c-2-8.6-4.2-17.1-6.4-25.6c-1.3-5-3.1-13.9-3.1-13.9s0.1,0,0.2,0
                c2-0.4,21.1-3.7,27.4-5.1c8.6-2,17.2-4,25.9-6c34.3-7.9,68.7-15.9,103-23.8c0.1,0.3,0.1,0.6,0.2,0.8
                c6.7,32.2,14.5,64.2,23.5,95.9C306.4,291.7,306.5,292.2,306.3,292.6z"/>
                </g>
                <g>
              <path class="st8" d="M282.5,194c0.1,0.3,0.2,1.1,0.3,1.4c-0.1,0.2-0.2,0.3-0.3,0.5c-3,4.4-7.5,7.5-11.2,11.3
                c-18.4,19-31.7,36.8-52.9,56.1c-0.8,0.8-1.9,1.2-3.1,1.3c-1.1,0.1-2.2-0.2-3.2-0.5c-21.6-6.6-41.2-17-61.9-25.8
                c-3.7-1.6-7.5-3.1-11.3-4.6c-0.9-0.4-1.9-0.7-2.8-1.1c-3-1.1-6.9-1.7-9.8-3.3c2-0.4,19.3-4.3,25.6-5.8c8.6-2,21.2-4.6,29.8-6.6
                C216,209.1,248.1,201.9,282.5,194z"/>
                </g>
              </g>
              <circle class="st9" cx="125.3" cy="229" r="25.7"/>
              <g>
            <path class="st10" d="M127.3,246.9l-13.3-8.7c-1.5-1-1.9-3-0.9-4.5c1-1.5,3-1.9,4.5-0.9l6.2,4.1l7.1-21.9c0.5-1.7,2.4-2.6,4-2.1
              c1.7,0.5,2.6,2.4,2.1,4L127.3,246.9z"/>
              </g>
            </g>
            <g style="clip-path:url(#SVGID_00000021842125271111864430000015084457460850680982_);">
              <g>
                <g>
              <path class="st11" d="M276.6,709.9c3.1,1,6.6,1.1,9.5,2.6c2.1,1.1,3.9,2.8,5.4,4.7c2,2.6,3.7,5.5,4.8,8.6
                c1.1,3,1.7,6.1,2.4,9.2c3.8,16.6,11.1,32.4,21.2,46.1c2.4,3.2,5,6.4,8.3,8.8s7.3,3.9,11.3,3.6c0.2-1.4-0.7-2.7-1.7-3.6
                c-1.1-0.9-2.4-1.4-3.7-2c-7.2-3.5-12.2-10.5-16.2-17.5c-8.3-14.4-14-30.1-18.7-46.1c-1.7-5.7-3.5-11.7-8.1-15.4
                c-4.9-3.9-12.3-4.5-15.7-9.7c0,0-7,3.6-6.6,5.2C269.2,706.9,274.6,709.2,276.6,709.9z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st12" d="M272.1,506.8c-0.3-0.8-0.5-1.6-0.7-2.5c-0.3-1.5-0.5-2.9-0.8-4.4c-0.2-1.2-1.8-1.1-3-0.9
                c-1.2,0.1-2.3,0.6-3.5,0.8c-1.1,0.2-2.3,0.1-3.5-0.1c-5-0.6-10-1.9-14.6-3.9c-1.7-0.7-3.5-1.7-4.3-3.4c0.4,0.9,7.4-6.6,7.9-7.4
                c2.2-3.3,4.4-7,5.8-10.7c1-2.7,3.4-8-0.8-9.1c-4-1.1-7.3,3.1-9.6,5.8c-2.8,3.1-5.2,6.7-6.1,10.8c-0.2,1.1-0.4,2.2-0.5,3.3
                c-0.2,1.9-0.3,3.9,0.1,5.8c-4.5,2.8-10,3.6-15.1,2.5c-1-0.2-2-0.5-2.6-1.3c3.4-1.3,6.3-3.4,9.1-5.6c2.1-1.6,4.3-3.3,6-5.3
                c0.8-1,1.5-2,2.2-3c2.1-3.3,3.9-6.8,5.2-10.5c0.9-2.4,1.5-5.2,0.2-7.3c-1-1.7-3-2.6-5-2.7c-2-0.1-3.9,0.6-5.6,1.5
                c-5.4,2.8-9.6,7.6-12.5,12.9c-1.4,2.7-2.6,5.6-3.3,8.6c-0.2,0.8-1.1,9.2-1.1,9.2c-3.8,1-8.2-0.3-11.5-2.5
                c-1.7-1.1-3.3-2.5-4.5-4.1c-1.9-2.7-2.6-6.2-2.1-9.5s2.2-6.4,4.6-8.7c-2-1.3-4.1-2.6-6.2-3.8c-1,2-1.9,4-2.6,6.1
                c-0.5,1.7-0.8,3.5-1,5.3c-0.4,2.8-0.8,5.7-0.1,8.4c1,3.6,3.8,6.5,7.2,8.2c2.7,1.4,5.4,2.8,8.4,3.3s6,0.5,9.1,0.5
                c0.6,1.5,2.2,2.7,3.7,3.3c1.5,0.6,3.2,0.7,4.9,0.8c2.4,0.1,4.8,0.2,7.1-0.3c2.3-0.5,4.6-1.5,6.3-3.2c1.3,1.5,3.1,2.9,4.8,3.9
                c2.4,1.4,5.1,2.2,7.8,2.9c2.7,0.7,5.4,1.5,8.1,1.8c2.8,0.3,5.6,0.2,8.2-0.7c-0.1,1.1,0.3,2.2,0.6,3.3c0.5,1.5,1,3,1.5,4.5
                c0.4,1.2,0.8,2.3,1.5,3.3c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.1c1.1,0.1,1.8-0.3,2.7-0.8
                C275.3,510.3,273,508.9,272.1,506.8z M219.9,487c0.7-2.8,1.6-5.6,2.7-8.2c2.3-5.8,5.7-11.1,10.6-15.2c1.1-0.9,6.2-4.4,7.1-1.9
                c0.8,2.1,0.7,4.4,0.1,6.5c-0.6,2.1-1.6,4.1-2.7,6c-1,1.9-2.1,3.8-3.5,5.4c-3.6,4.5-8.9,7.3-14,9.8
                C220,488.6,219.7,487.8,219.9,487z M240.6,485.6c0-1.6,0.2-3.1,0.8-4.6c0.3-0.8,0.7-1.5,1.1-2.2c2.4-4,5.8-7.4,9.7-9.8
                c0.2,0.7,0.2,1.5,0.2,2.2c-0.1,1.1-0.5,2.2-0.9,3.3c-0.6,1.7-1.2,3.3-2,4.9c-1.1,2-2.5,3.7-4,5.4c-1.5,1.7-3.1,3.5-4.9,5
                C240.6,488.2,240.6,487,240.6,485.6z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st13" d="M399.9,130.7c1.6-2.6,3.9-5.2,3.2-8.2c-0.4-1.5-1.5-2.7-2.7-3.6c-3.8-2.8-8.8-3.2-13.4-3.7
                c-3.8-0.4-7.6-1-11.3-1.7c-1.9-0.3-3.8-0.6-5.5-1.3c-2.8-1.1-5.2-3.2-7.4-5.3c-0.9-0.8-1.6-1.6-2.1-2.7
                c2.2-1.3,4.6-2.3,6.7-3.8c2.1-1.5,3.8-3.7,4.1-6.3c0.3-2.6-1.4-5.4-4-5.7c-2.3-0.3-4.4,1.4-6,3.1c-1.5,1.5-2.9,3-3.9,4.9
                c-1,1.8-1.5,4.2-1.1,6.2c-1.4,1.1-3.4,1.1-5.2,0.9c-2.4-0.2-4.8-0.6-7.1-1.1c-1.7-0.3-3.5-0.8-4.5-2.2c-1-1.3-1-3.2-0.4-4.8
                c0.6-1.6,1.7-2.9,2.7-4.1c1.9,0.6,4,0.6,6,0.5c3.6-0.1,7.3-0.3,10.3-2.3c1.4-0.9,2.5-2.2,2.9-3.8c0.4-1.6-0.2-3.4-1.6-4.3
                c-1-0.6-2.3-0.6-3.4-0.5c-4.8,0.6-9.3,3.5-13.3,6.2c-4.2-1.5-7.8-4.9-9.4-9.1c-2-5.1-1.2-10.9-0.1-16.3
                c0.6-2.8,1.4-5.8,3.6-7.7c-2.3-0.8-4.6-1.6-6.8-2.3c0.3,4.8-0.6,9.5-1.1,14.2c-0.5,4.7-0.7,9.6,0.8,14.2
                c1.5,4.4,4.7,8.3,8.9,10.6c-2.4,1.4-4,4.2-3.9,7c0.1,2.8,1.8,5.5,4.4,6.7c1.1,0.5,2.3,0.8,3.5,1c4.6,0.9,9.3,0.9,14,0.8
                c2,2.6,4.6,4.7,7.4,6.2c3.4,1.8,7.1,2.7,10.8,3.5c4.7,1,9.5,1.8,14.3,2.4c3.4,0.4,7.1,0.9,9.5,3.5c0.3,0.3,0.5,0.6,0.6,1
                c0.1,0.5,0,1-0.2,1.5c-2.3,6.6-7.7,11.8-10,18.5c-0.7,2.1-1.1,4.2-1.2,6.4c0,1.6,0.1,3.3,0.8,4.8c1.3,2.6,4,4.2,6.5,5.5
                c0,0.1,0.1,0,0.2,0c0.3-0.7,0.5-1.4,0.8-2.1c-1,0.1-2.1-0.4-2.8-1.1c-0.7-0.7-1.2-1.7-1.7-2.7c-0.7-1.5-1.7-3.7-1.3-5.3
                C391.6,141.9,396.2,136.5,399.9,130.7z M347.6,85.8c0.8-0.5,1.6-1,2.5-1.4c1.9-1,3.8-2,5.9-2.1c0.9-0.1,2.1,0.1,2.5,1
                c0.1,0.3,0.2,0.6,0.2,0.8c0,0.9-0.2,1.9-0.9,2.5c-0.8,0.7-2,0.9-3.1,1c-3,0.2-6.1,0.2-9.1,0.1C345.6,87,347,86.2,347.6,85.8z
                M359.6,100.4c0.1-2,0.7-3.9,1.8-5.6c0.4-0.6,0.9-1.2,1.5-1.8c0.4-0.4,0.8-0.9,1.2-1.2c1-0.8,2.5-0.9,3.7-0.4
                c0.7,0.3,1.1,0.9,1.3,1.6c0.2,0.7,0.2,1.4,0.1,2.1c-0.2,1-0.8,2-1.6,2.7c-1,0.9-2.2,1.6-3.4,2.1c-1,0.4-2,0.8-3,1.2
                C360.1,101.5,359.5,101.8,359.6,100.4z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st14" d="M693.6,317.8c-2.3-0.9-4.8-1.7-7.2-2.2c-1.7-0.3-3.4-0.5-5.1-0.6c-0.8,0-1.6-0.1-2.4-0.1
                c-0.4,0-2.1,0.3-2.4,0.1c-2.3-1.8-4.2-4-5.7-6.5c-0.9-1.4-0.3-2.5,1-3.3c3.1-2,7.4-2.3,10.9-2.7c0.7-0.1,3.1,0.1,3.5-0.4
                c0.3-0.3,0.1-1.6,0.1-2.1c0-0.7,0-1.3,0-2c-0.1-1.4-0.2-2.7-0.4-4.1c0-0.3-0.2-0.5-0.3-0.7c-1.5,0.2-2.9,0.7-4.3,1.1
                c-1.3,0.4-2.7,0.9-4,1.3c-2.8,0.9-5.7,1.9-8.3,3.3c-2.4,1.4-4.5,3.7-4.4,6.6c0,0.6,0.1,1.3,0.3,1.9c0.9,3.5,3.1,6.6,6.1,8.6
                c-1.7-0.1-3.4,0.2-4.9,0.9c-1.5,0.7-2.8,2-3.5,3.5c-0.9,1.9-0.8,4.1-0.1,6c0.7,1.9,1.9,3.5,3.4,4.9c-0.9,1.1-1.7,2.4-2.4,3.7
                c-1.9,3.6-3.4,7.4-4.4,11.3c-0.9,3.3-1.5,6.7-1.4,10c0.8-0.3,1.7-0.6,2.2-1.3c0.4-0.5,0.5-1.2,0.5-1.8c0.1-0.8,0.3-1.7,0.3-2.5
                c0.5-4.4,2.2-8.5,3.9-12.6c0.8-1.8,1.5-3.5,3-4.7c1.5,1,3.1,2.1,4.6,3.1c0.8,0.6,1.7,1.1,2.6,1.6c1,0.5,2.1,0.8,3.1,1.3
                c1.4,0.5,2.7,1.2,4.2,1.5c1.5,0.3,3.1,0.2,4.3-0.7c0.5-0.3,0.9-0.8,1-1.4c0.1-0.6,0-1.2-0.3-1.8c-1.1-2.3-4-4-6.1-5.3
                c-2.4-1.4-5.1-2.6-7.9-2.8c-1.4-0.1-2.8,0.2-4.1,0.5c-0.9-0.8-1.5-1.9-2.1-3c-0.5-0.9-0.9-1.8-1.1-2.8s0.1-2.1,0.8-2.7
                c0.4-0.3,0.8-0.6,1.3-0.8c2.4-1,4.9-2,7.5-1.6c1.6,1.7,3.7,2.7,5.8,3.5c3.2,1.3,6.7,2.2,10.2,1.7c1.1-0.2,2.2-0.5,3.3-0.8
                c0.8-0.3,1.6-0.6,2.2-1.2C699.2,319.8,695.3,318.5,693.6,317.8z M674.3,331.8c2.2,0.7,4.2,1.5,6.2,2.7c1,0.6,3.7,1.8,3.8,3.2
                c0,0.1,0,0.2,0,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.6,0.3-1.4,0.1-2.1-0.1c-3.2-1-6.4-2.4-8.9-4.5c-0.8-0.6-1.6-1.3-2.1-2.1
                C672,331.2,673.2,331.5,674.3,331.8z M694.7,320.9c-1.7,1.5-4.5,1-6.5,0.7c-0.2,0-0.3-0.1-0.5-0.1c-2.2-0.4-4.4-1-6.2-2.2
                c-0.7-0.4-0.6-0.5,0.2-0.7c2-0.5,4.5-0.2,6.5,0c2.2,0.2,4.5,0.6,6.5,1.8c0.1,0.1,0.2,0.1,0.2,0.2
                C694.9,320.7,694.8,320.8,694.7,320.9z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M304,162.7c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0-0.2,0-0.4c-0.1-0.8,0-3.9-0.7-4.4c-0.6-0.4-2.9,0.7-3.5,1
                c-1.8,1.1-1.8,3.7-2.6,5.5C299.8,164,301.9,163.3,304,162.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M437.2,52.3c-0.3,1.8-1.7,3.2-3.1,4.4c-0.3-1.2-1.3-2.2-2.4-2.6c-0.1-0.1-0.3-0.1-0.4-0.2
                c-0.3-0.3,0-0.8,0.3-1.1c0.8-1.1,1.2-2.3,1.3-3.6c0.6,0.7,0.8,1.5,1.6,2.2C434.8,51.4,437.2,52.7,437.2,52.3z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M142.6,152.3c0.1,0,0.3,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0.1,1.6,0.3,3.2,0.4,4.9
                c-1.4-0.2-2.8-0.6-4.2-1.1c-0.2-0.1-0.4-0.1-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5c-0.3-0.6-1-0.9-1.1-1.5c0-0.3,0.1-0.6,0.2-0.8
                c0.4-1.2,0.6-2.5,0.9-3.7C139.8,150.8,141.1,151.7,142.6,152.3z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M224.5,82.9c0.3,0.1,0.6,0.1,0.8,0c0.2-0.1,0.4-0.2,0.6-0.3c1.1-0.7,2-1.6,2.9-2.5
                c-1.5-0.5-2.8-1.6-3.5-3c-1,0.2-1.9,0.6-2.8,1.1c-0.6,0.3-2.2,1-2.3,1.7C219.9,81.3,223.5,82.7,224.5,82.9z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M255.8,370.7c1,0.2,2,0.7,2.9,1.3c0.6,0.4,1.2,0.9,1.9,0.8c0.3-1.6,0.5-3.2,0.5-4.8
                c0-0.3-1.9-0.8-2.1-0.9c-0.8-0.2-1.6-0.3-2.4-0.3c-0.9,0.1-0.7,0.3-0.6,1C256,368.9,255.9,369.8,255.8,370.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M52.6,342.1c1.7-1.4,3.2-3,4.6-4.7c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3
                c-1.1-1.8-2.3-3.6-3.4-5.4c0.2,0.3-2.1,2.1-2.3,2.3c-0.9,0.6-2.2,0.9-1.4,2C51.3,337.7,52.3,339.7,52.6,342.1z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M376.8,225.8c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.3-0.1c1.4-0.6,2.6-1.6,3.4-2.9
                c-1-0.5-1.8-1.4-2.1-2.5c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.3,0-0.5,0c-0.8,0.3-4.3,1.3-4.3,2.2c0,0.5,1,1.2,1.3,1.6
                C375.7,224.6,376.2,225.2,376.8,225.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M398.6,170.4c1.1-0.5,2.3-0.8,3.5-0.7c0.4-1.2,0.8-2.4,1.3-3.6c-0.1,0.3-2.1,0-2.4,0
                c-0.4-0.1-2-0.7-2.3-0.5c-0.3,0.2-0.1,1.7-0.1,2C398.5,168.5,398.5,169.4,398.6,170.4z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M576.4,201.8c0.9-0.4,1.8-0.8,2.4-1.6c-0.8-0.9-1.4-1.8-2-2.8c-0.1,0.3-0.3,0.5-0.6,0.7
                c-0.4,0.3-0.8,0.6-1.2,0.9c-0.4,0.3-0.8,0.3-0.6,0.8C574.5,199.9,576.4,201.7,576.4,201.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M540.7,97.8c0.1,0,0.3,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0.1,1.6,0.3,3.2,0.4,4.9
                c-1.4-0.2-2.8-0.6-4.2-1.1c-0.2-0.1-0.4-0.1-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5c-0.3-0.6-1-0.9-1.1-1.5c0-0.3,0.1-0.6,0.2-0.8
                c0.4-1.2,0.6-2.5,0.9-3.7C537.9,96.3,539.2,97.2,540.7,97.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M662.9,135.8c0.9,0.3,1.9,0.7,2.8,1c-1.1,0.9-2.2,1.9-3.2,3c-0.4,0.4-0.8,0.9-1.4,0.8
                c-0.2,0-0.4-0.1-0.6-0.2c-0.7-0.3-1.4-0.7-2.1-1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1,0-0.3,0.1-0.5c0.4-0.6,0.8-1.3,1.2-1.9
                c0.3-0.6,0.7-1.4,1.1-1.9c0.5-0.4,0.2-0.2,0.7,0.1C661.7,135.4,662.3,135.6,662.9,135.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M726.4,311.5c0.3,0.1,0.6,0.1,0.8,0c0.2-0.1,0.4-0.2,0.6-0.3c1.1-0.7,2-1.6,2.9-2.5
                c-1.5-0.5-2.8-1.6-3.5-3c-1,0.2-1.9,0.6-2.8,1.1c-0.6,0.3-2.2,1-2.3,1.7C721.8,309.8,725.4,311.3,726.4,311.5z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M617.2,385.5c1,0.2,2,0.7,2.9,1.3c0.6,0.4,1.2,0.9,1.9,0.8c0.3-1.6,0.5-3.2,0.5-4.8
                c0-0.3-1.9-0.8-2.1-0.9c-0.8-0.2-1.6-0.3-2.4-0.3c-0.9,0.1-0.7,0.3-0.6,1C617.4,383.6,617.3,384.6,617.2,385.5z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M79.7,542.3c1,0.2,2,0.7,2.9,1.3c0.6,0.4,1.2,0.9,1.9,0.8c0.3-1.6,0.5-3.2,0.5-4.8c0-0.3-1.9-0.8-2.1-0.9
                c-0.8-0.2-1.6-0.3-2.4-0.3c-0.9,0.1-0.7,0.3-0.6,1C79.9,540.4,79.8,541.4,79.7,542.3z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M656.3,253c1.7-1.4,3.2-3,4.6-4.7c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3
                c-1.1-1.8-2.3-3.6-3.4-5.4c0.2,0.3-2.1,2.1-2.3,2.3c-0.9,0.6-2.2,0.9-1.4,2C655,248.6,656,250.6,656.3,253z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M718.8,239.5c0,0.2,0.1,0.3,0.2,0.4c0.2,0.3,0.7,0.4,1.1,0.5c0.9,0.1,1.7,0,2.6-0.2
                c0.1-1.2,0-2.5-0.3-3.7c-1.1,0-2.3,0-3.3,0.4c-0.6,0.2-0.5,0.3-0.4,0.9C718.7,238.4,718.7,238.9,718.8,239.5z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M758.8,397.7c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0,0.2,0c1.1,0,2.1-0.3,3.2-0.2c-0.5-0.8-0.9-1.7-1.4-2.5
                c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.3,0c-1.2,0-2.4,0-3.6,0.1C757.8,395.3,758.4,397,758.8,397.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M757.2,219.2c0.8-1,1.7-2.1,2.5-3.1c-1.4-1.5-2.7-3.1-3.8-4.8c0.1,0.2-1.4,2-1.6,2.3
                c-0.4,0.5-1.4,1.5-1.2,2.1c0.1,0.4,1.6,1.2,2,1.6C755.8,217.8,756.5,218.5,757.2,219.2z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M160.3,477.9c-0.4-1.1-0.8-2.3-1-3.4c-0.9,0.3-1.8,0.5-2.6,0.8c0.1,0,0.5,2.9,0.8,3
                c0.2,0.1,0.9-0.1,1.1-0.1C159.1,478.1,159.7,478,160.3,477.9z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M426.8,647.4c0.2-1,0.7-2,1.3-2.9c0.4-0.6,0.9-1.2,0.8-1.9c-1.6-0.3-3.2-0.5-4.8-0.5
                c-0.3,0-0.8,1.9-0.9,2.1c-0.2,0.8-0.3,1.6-0.3,2.4c0.1,0.9,0.3,0.7,1,0.6C424.9,647.2,425.9,647.3,426.8,647.4z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M369.8,757.3c0.2-1,0.7-2,1.3-2.9c0.4-0.6,0.9-1.2,0.8-1.9c-1.6-0.3-3.2-0.5-4.8-0.5
                c-0.3,0-0.8,1.9-0.9,2.1c-0.2,0.8-0.3,1.6-0.3,2.4c0.1,0.9,0.3,0.7,1,0.6C367.9,757.1,368.9,757.2,369.8,757.3z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M143.7,396.5c-1.4-1.7-3-3.2-4.7-4.6c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.3,0.1
                c-1.8,1.1-3.6,2.3-5.4,3.4c0.3-0.2,2.1,2.1,2.3,2.3c0.6,0.9,0.9,2.2,2,1.4C139.2,397.8,141.3,396.8,143.7,396.5z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M280.8,545.7c0.2,0,0.3-0.1,0.4-0.2c0.3-0.2,0.4-0.7,0.5-1.1c0.1-0.9,0-1.7-0.2-2.6
                c-1.2-0.1-2.5,0-3.7,0.3c0,1.1,0,2.3,0.4,3.3c0.2,0.6,0.3,0.5,0.9,0.4C279.7,545.9,280.3,545.9,280.8,545.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M341.3,454.8c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2c0-1.1-0.3-2.1-0.2-3.2c-0.8,0.5-1.7,0.9-2.5,1.4
                c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.2,0,0.3c0,1.2,0,2.4,0.1,3.6C338.9,455.8,340.6,455.3,341.3,454.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M46,452.8c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.1,0-0.2c0-1.1-0.3-2.1-0.2-3.2c-0.8,0.5-1.7,0.9-2.5,1.4
                c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.2,0,0.3c0,1.2,0,2.4,0.1,3.6C43.7,453.8,45.3,453.2,46,452.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M612.7,560.3c-1-0.8-2.1-1.7-3.1-2.5c-1.5,1.4-3.1,2.7-4.8,3.8c0.2-0.1,2,1.4,2.3,1.6
                c0.5,0.4,1.5,1.4,2.1,1.2c0.4-0.1,1.2-1.6,1.6-2C611.4,561.7,612,561,612.7,560.3z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M227.9,702.8c-1-0.8-2.1-1.7-3.1-2.5c-1.5,1.4-3.1,2.7-4.8,3.8c0.2-0.1,2,1.4,2.3,1.6
                c0.5,0.4,1.5,1.4,2.1,1.2c0.4-0.1,1.2-1.6,1.6-2C226.5,704.2,227.2,703.5,227.9,702.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M481.7,502.6c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2,0-0.4,0c-0.8,0.1-3.9,0-4.4,0.7c-0.4,0.6,0.7,2.9,1,3.5
                c1.1,1.8,3.7,1.8,5.5,2.6C483,506.8,482.3,504.6,481.7,502.6z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M441.4,462.8c-0.4-1.1-0.8-2.3-1-3.4c-0.9,0.3-1.8,0.5-2.6,0.8c0.1,0,0.5,2.9,0.8,3
                c0.2,0.1,0.9-0.1,1.1-0.1C440.2,462.9,440.8,462.9,441.4,462.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M290.8,629.8c-0.4-1.1-0.8-2.3-1-3.4c-0.9,0.3-1.8,0.5-2.6,0.8c0.1,0,0.5,2.9,0.8,3
                c0.2,0.1,0.9-0.1,1.1-0.1C289.6,629.9,290.2,629.9,290.8,629.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M524.2,673.1c-0.4-0.9-0.8-1.8-1.6-2.4c-0.9,0.8-1.8,1.4-2.8,2c0.3,0.1,0.5,0.3,0.7,0.6
                c0.3,0.4,0.6,0.8,0.9,1.2c0.3,0.4,0.3,0.8,0.8,0.6C522.4,674.9,524.2,673,524.2,673.1z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M369.1,621.8c1.8,0.3,3.2,1.7,4.4,3.1c-1.2,0.3-2.2,1.3-2.6,2.4c-0.1,0.1-0.1,0.3-0.2,0.4
                c-0.3,0.3-0.8,0-1.1-0.3c-1.1-0.8-2.3-1.2-3.6-1.3c0.7-0.6,1.5-0.8,2.2-1.6C368.3,624.3,369.5,621.9,369.1,621.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M197.7,598.8c0.3-0.9,0.7-1.9,1-2.8c0.9,1.1,1.9,2.2,3,3.2c0.4,0.4,0.9,0.8,0.8,1.4
                c0,0.2-0.1,0.4-0.2,0.6c-0.3,0.7-0.7,1.4-1,2.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.3,0-0.5-0.1c-0.6-0.4-1.3-0.8-1.9-1.2
                c-0.6-0.3-1.4-0.7-1.9-1.1c-0.4-0.5-0.2-0.2,0.1-0.7C197.3,600,197.5,599.4,197.7,598.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M749.3,705.7c0.2,0,0.3-0.1,0.4-0.2c0.3-0.2,0.4-0.7,0.5-1.1c0.1-0.9,0-1.7-0.2-2.6
                c-1.2-0.1-2.5,0-3.7,0.3c0,1.1,0,2.3,0.4,3.3c0.2,0.6,0.3,0.5,0.9,0.4C748.2,705.9,748.7,705.8,749.3,705.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M710.6,461.7c-1-0.8-2.1-1.7-3.1-2.5c-1.5,1.4-3.1,2.7-4.8,3.8c0.2-0.1,2,1.4,2.3,1.6
                c0.5,0.4,1.5,1.4,2.1,1.2c0.4-0.1,1.2-1.6,1.6-2C709.3,463.1,710,462.4,710.6,461.7z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M544.7,429.8c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3c-0.6-1.4-1.6-2.6-2.9-3.4
                c-0.5,1-1.4,1.8-2.5,2.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1,0,0.3,0,0.5c0.3,0.8,1.3,4.3,2.2,4.3c0.5,0,1.2-1,1.6-1.3
                C543.6,430.9,544.1,430.4,544.7,429.8z"/>
                </g>
              </g>
              <g>
                <g>
              <path class="st15" d="M488.3,391c-0.5-1.1-0.8-2.3-0.7-3.5c-1.2-0.4-2.4-0.8-3.6-1.3c0.3,0.1,0,2.1,0,2.4
                c-0.1,0.4-0.7,2-0.5,2.3c0.2,0.3,1.7,0.1,2,0.1C486.4,391.1,487.4,391,488.3,391z"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <h5>{{'jobboard.views.start-phone-call.success.title' | transloco}}</h5>
      <p [innerHTML]="'jobboard.views.start-phone-call.success.text' | transloco"></p>
    </div>
  }
  @if (state === 'failed' || state === 'no-missing-data') {
    <div class="ct-card verify-failed">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 840 802.8" style="enable-background:new 0 0 840 802.8;" xml:space="preserve">
        <style type="text/css">
          .st0{enable-background:new}
          .st1{fill:none;stroke:#ED6A6C;stroke-width:20.7713;stroke-linecap:round;stroke-miterlimit:10;}
          .st2{fill:#D1D1D1;}
          .st3{fill:none;stroke:#807F7F;stroke-width:3.2121;stroke-linecap:round;stroke-miterlimit:10;}
          .st4{clip-path:url(#SVGID_00000170963352849182745090000002499043660905208765_);}
          .st5{fill:#37474F;}
          .st6{fill:#F2908B;}
          .st7{fill:#2C353E;}
          .st8{fill:#045E79;}
          .st9{fill:none;stroke:#035164;stroke-width:2.3738;stroke-miterlimit:10;}
        </style>
        <g id="Capa_1_00000168100818091285833970000004488622539197410483_">
        </g>
        <g id="Capa_2_00000062880003977758677400000013991696955964469429_">
      <path class="st0" [style]="'fill: ' + correctedBackgroundColor" d="M509.2,765.2c62.7-12.9,123.4-37.5,175.2-71.3C846.4,588.2,850,350,770.6,192.3c-2.5-5-5.1-10-7.9-14.8
        C701.2,66.7,573.6,12.4,452.7,47.3C390.8,65.1,330,93.9,287.2,142.1c-51.1,57.5-71.9,137-122.2,195.3c-21.9,25.4-48.9,46.1-70,72.2
        C68.5,442.3,52.1,483,48.5,524.9C39.2,633,153.6,710.4,242,743.1C326.5,774.3,421.1,783.4,509.2,765.2z"/>
          <g>
            <line class="st1" x1="192.3" y1="361.7" x2="257.1" y2="237.1"/>
            <line class="st1" x1="285.7" y1="334.3" x2="163.8" y2="264.6"/>
            <circle class="st1" cx="225" cy="298.8" r="107.5"/>
          </g>
          <g>
        <path class="st2" d="M353.8,181.6c-30.5,0-55.2,24.7-55.2,55.2s24.7,55.2,55.2,55.2s55.2-24.7,55.2-55.2S384.3,181.6,353.8,181.6z
          M375.5,208.4c5.9,0,10.6,4.8,10.6,10.6c0,5.9-4.8,10.6-10.6,10.6c-5.9,0-10.6-4.8-10.6-10.6C364.9,213.1,369.7,208.4,375.5,208.4
          z M332.1,208.4c5.9,0,10.6,4.8,10.6,10.6c0,5.9-4.8,10.6-10.6,10.6c-5.9,0-10.6-4.8-10.6-10.6
          C321.5,213.1,326.2,208.4,332.1,208.4z"/>
            <path class="st3" d="M328,263.1L328,263.1c12.8-16.1,37-16.6,50.6-1.1l1,1.1"/>
          </g>
          <g>
            <g>
              <defs>
            <path id="SVGID_1_" d="M509.2,765.2c62.7-12.9,123.4-37.5,175.2-71.3C846.4,588.2,850,350,770.6,192.3c-2.5-5-5.1-10-7.9-14.8
              C701.2,66.7,573.6,12.4,452.7,47.3C390.8,65.1,330,93.9,287.2,142.1c-51.1,57.5-71.9,137-122.2,195.3
              c-21.9,25.4-48.9,46.1-70,72.2C68.5,442.3,52.1,483,48.5,524.9C39.2,633,153.6,710.4,242,743.1
              C326.5,774.3,421.1,783.4,509.2,765.2z"/>
              </defs>
              <clipPath id="SVGID_00000124860624764257718750000014364308309472826533_">
                <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
              </clipPath>
              <g style="clip-path:url(#SVGID_00000124860624764257718750000014364308309472826533_);">
            <path class="st5" d="M450.7,698.6c-21.3,48.5-21.3,103.3-20.9,156.3c0.2,20.6,0.3,41.2,0.5,61.8c0.1,13.6,0.2,27.2,2.5,40.6
              c0.3,1.9,0.7,3.9,0.3,5.8c-0.5,2.6-2.2,4.7-3.4,7c-4.2,8.4-0.6,18.3,0,27.7c0.6,8.5-1.3,16.9-2.6,25.3
              c-2.5,15.7-3.2,31.7-2.1,47.5c2.3,31.7,0.1,63.3,4.4,94.9c0.5,3.8,1.2,7.8,3.3,11c2.8,4.1,8.1,8.3,5.7,12.6
              c-1.6,2.9-6,3.2-7.8,6c-1.5,2.3-0.8,5.3,0,7.9c1.6,5.5,3.3,11,4.9,16.5c0.3,1.1,0.7,2.3,1.6,3.1c0.9,0.8,2.1,1,3.3,1.2
              c16.6,2.9,33.7,2.8,50.3-0.3c2.7-0.5,6.1-1.9,5.9-4.7c-0.1-1.7-1.5-2.9-2.1-4.5c-1.4-3.8,2.5-7.3,3.6-11.1
              c0.9-3.1-0.1-6.3-0.7-9.5c-2.1-10.8-0.3-21.9,1-32.8c5.3-45.7,1.1-91.9,1.7-137.8c0-2.9,0.1-5.9-0.4-8.7
              c-0.2-1.1-0.5-2.3-0.5-3.4c0.1-1.8,1.2-3.4,2.2-5c7-11.2,10-24.5,12.8-37.4c1.2-5.4,0.4-10.4,1.4-15.9
              c6.8-40.1,18-79.5,33.1-117.2c1.1-2.6,2.4-5.5,5.1-6.4c2.2,2.1,2.6,5.5,3.2,8.5c1.9,10.3,7.7,19.5,11.6,29.3
              c4.7,11.7,6.8,24.3,8.9,36.8c4.5,26.9,8.9,53.8,13.4,80.6c0.7,4.4,1.4,8.7,2.5,13c1,3.9,2.5,8,6,10c1,0.6,2.4,1.1,2.5,2.3
              c0.1,1-0.8,1.7-1.4,2.5c-2.2,2.6-2,6.3-1.8,9.7c0.8,11.2,1.6,22.5,2.5,33.7c1.9,25.5,0.7,49.2,3.4,74.6
              c0.5,5.2,1.4,10.4,3.2,15.2c1.3,3.5,3.2,6.8,4.6,10.3c3.2,8.1,3.5,17,3.7,25.7c0.1,4.7,0.3,9.3-0.5,13.9
              c-0.4,2.5-1.2,4.9-1.4,7.5c-0.4,4.5,1.7,7.8,2.4,12c0.6,3.3,1.4,7,4.1,9.1c3.6,2.8,8.8,1.3,13.3,1c3.4-0.2,6.7,0.2,10.1,0.5
              c10.1,0.8,20.4,0.1,30.3-2.2c0.3-0.1,0.6-0.1,0.8-0.3c0.3-0.3,0.3-0.7,0.4-1.1c0.5-4.9,1.7-10.5,1.8-15.3
              c0.1-5.7-5.7-9-5.7-14.3c0-2.2,1.4-4.2,2.3-6.2c3.1-7,0.8-15.1-0.1-22.8c-0.7-5.9-0.4-11.8-0.1-17.6
              c2.5-39.3,10.5-79.1,2.2-117.6c-1.2-5.5-2.7-11.2-1.9-16.7c0.4-2.5,1.1-5.4-0.6-7.3c-0.6-0.6-1.4-1.1-1.6-1.9
              c-0.2-0.8,0.3-1.6,0.7-2.2c2.8-4.6,5.4-10.1,3.6-15.3c-1.3-3.8-4.6-6.5-6.4-10.1c-1.8-3.6-0.7-9.3,3.3-9.6
              c2.8-6.3,1.1-14,0.6-20.9c-0.8-10.5-2.3-19.8-2-30.5c0.5-12.6,1-25.2,1.4-37.8c0.8-25.5,1.2-51.1-0.4-76.6
              c-2.2-34.8-7.3-69.5-15.1-103.5c-54-16-111-25.8-166.8-17.9c-8.2,1.2-16.5,2.8-23.9,6.6C459.4,687.6,454,691,450.7,698.6z"/>
            <path class="st6" d="M493.9,360.9c3.1,13.2,11.1,25.2,22.1,33.2c3.9,2.8,8.1,5.2,12.4,7.4c6,3.2,12.3,6.3,19.1,6.3
              c4.9,0,9.6-1.7,13.9-3.9c9.5-4.8,17.6-11.8,25.7-18.8c6.3-5.5,12.7-11.1,18.3-17.3c2.7-3,5.3-6.3,6.5-10.1
              c1.2-3.9,0.7-8.5-2.1-11.4c-2.2-2.3-5.3-3.2-7.9-4.9c-7.4-4.8-7-12.4-7.4-20.2c-0.3-7.6-0.6-15.5,0.4-23
              c0.6-4.2,1.6-8.2,3.3-12.1c0.3-0.6,0.6-1.3,0.9-1.9c1.4,2.2,4.8,2.3,6.9,0.8c2.2-1.5,3.3-4,4.3-6.5c2.8-7,5.1-14.2,6.8-21.6
              c0.9-4.1,1.6-8.8-0.8-12.3c-2.4-3.5-9-3.7-10,0.4c3.7-15-2.3-33.8-8.2-47.4c-5.6-13.1-18.3-17-31.7-17.4
              c-15.9-0.5-33.6-0.4-45.4,10.3c-8.1,7.3-11.8,18.2-15.2,28.6c-2.3,7-4.6,14.2-3.6,21.5c-0.5-2.5-2-4.9-4.5-5.1
              c-2.2-0.3-4.3,1.5-5.1,3.6c-0.8,2.1-0.8,4.4-0.6,6.6c0.2,4.9,0.4,9.8,0.6,14.7c0.2,4.8,0.5,9.7,2.4,14.2
              c1.9,4.4,5.9,8.3,10.7,8.5v0.1c0,3.4-0.1,6.8,0.9,10.1c1.3,4.2,2.6,8.3,3.9,12.5c0.9,2.8,2.9,5.1,3.7,8c0.1,0.3,0.2,0.6,0.2,0.8
              c0.5,2.4,0.3,4.9,0.1,7.4c-0.3,3.2-0.3,6.5-0.8,9.7s-1.4,4-3.9,6.4c-4.8,4.8-9.5,9.7-14.1,14.8c-0.7,0.8-1.5,1.6-1.9,2.7
              C493.1,357.2,493.5,359.1,493.9,360.9z"/>
            <path class="st7" d="M574.3,152.5c10.5,6.5,19.9,14.6,27.9,24c1.8,2.1,3.5,4.2,4.6,6.7c1.2,2.8,1.5,5.9,1.8,8.9
              c0.8,7.8,1.6,15.7,2.4,23.5c0.8,7.6-1,12.7-1.1,20.4c0,2.4-0.1,4.9-0.9,7.2c-0.7,2-2.1,3.8-3.3,5.6c-3.6,5.4-6,11.7-7,18.1
              c1.2-14.9-0.4-29.9-2.1-44.8c-0.8-7-1.7-14.2-5.5-20.2c-3.8-5.9-11.3-10.1-17.9-7.7c-3.7,1.4-6.5,4.5-10.1,6.1
              c-11.9,5.2-26.6-8-38-1.6c-5.6,3.1-7.9,9.8-9.7,15.9c-3.7,12.3-7.5,24.9-7.2,37.7c0.2,8.2,2.1,16.8-0.8,24.4
              c-0.9-9.4-1.8-18.8-3.9-28c-1.3-5.6-3.1-11.2-3.5-16.9c-0.4-5.2,0.2-10.4,0.9-15.5c1.6-12.5,3.2-25.3,8.6-36.7
              c0.4-0.8,0.8-1.7,0.9-2.6c0.1-1.4-0.6-2.6-0.9-4c-0.7-3.2,0.8-6.5,3.2-8.7c2.3-2.2,5.4-3.6,8.3-4.9c5.3-2.3,10.5-4.7,15.8-7
              c3.9-1.7,7.8-3.5,12-4c5.3-0.7,10.7,0.5,15.9,1.7C568.6,151.1,571,150.4,574.3,152.5z"/>
            <path class="st7" d="M509.8,305c0.5,1.2,1.1,2.4,1.7,3.5c2.4,4.8,4.5,10.1,7.7,14.5c2.3,3.3,5.1,6.3,8.2,8.9
              c11.4,9.5,22.4,11.8,35.3,3.7c10-6.3,19-14.5,25.2-24.7c2.4-3.9,5-8,6.5-12.4c0.3-0.9,0.6-1.8,0.8-2.8c0.9-3.4,2-6.8,3-10.1
              c0.7-2.4,0-5.1-0.4-7.5c-1.1,0.7-1.4,2.5-2,3.7c-1.9,4-3.6,7.8-6.7,10.9c-2.5,2.5-5.3,4.9-7.4,7.7c-5.3,7.1-11.4,13.7-18.2,19.4
              c-1.2,1.1-2.6,2.1-4.1,2.5c-1.6,0.4-3.5-0.2-4.2-1.7s0.1-3.4-0.6-4.9c-0.7-1.7-2.8-2.2-4.6-2.3c-1.8-0.1-3.9,0.2-4.9,1.7
              c-1.3,2,0.2,4.7-0.8,6.9c-0.9,2-3.7,2.6-5.7,1.8c-2.1-0.8-3.6-2.5-5-4.2c-1.8-2.2-3.7-4.3-5.5-6.5c-3.9-4.6-7.7-9.3-11.2-14.2
              c-3.4-4.6-6.8-9.4-9.3-14.6c-0.3-0.7-0.9-1.4-1.7-1.6c-0.1,0.1-0.2,0.1-0.3,0.2c-1.4,1.2,0.3,8.9,0.6,10.7
              C506.8,297.7,508.1,301.4,509.8,305z"/>
            <path class="st7" d="M520.2,291.1c0.9-0.7,1.9-1.3,2.9-1.9c1.8-1.2,3.5-1.8,5.7-2.1c3.9-0.6,7.9-0.4,11.7,0.6s7.6,2.7,11.6,2.6
              c2.2,0,4.4-0.6,6.6-0.9c6.5-0.8,13.4,0.9,18.7,4.8c3.2,2.3,6,6.4,6.9,10.2c-2.4,1.8-5.6-0.8-7.8-2.8c-5.1-4.6-12.3-6.7-19-5.6
              c-2.5,0.4-5,1.3-7.6,1.3c-3.9,0-7.5-2-11.4-2.8c-4.4-0.9-9.1-0.3-13.1,1.6c-1.8,0.9-8,6.5-10.2,4c-0.9-1.1-0.9-2.7-0.3-4
              c0.6-1.3,1.7-2.3,2.8-3.2C518.5,292.4,519.3,291.7,520.2,291.1z"/>
            <path class="st8" [style]="'fill: ' + colorService.accent" d="M664.7,694.7c1.9-3.3,0.7-3.1-2-5.5c-2.5-2.2-1.7-6.4,0.3-9c2.1-2.6,5.1-4.2,7.4-6.6
              c7.5-7.8,5.3-20.6,1.2-30.6s-9.6-20.5-7.2-31.1c10.7,2.3,22.1-2.2,30.1-9.8c8-7.5,12.9-17.7,16.5-28.1
              c12.9-37.9,8.8-79.3,2.5-118.8c-2-12.7-4.2-25.5-8.9-37.5c-9.3-24-28.6-43.9-52.3-54c-2.3-1-4.7-1.9-7.2-2.3
              c-2.1-0.4-4.3-0.4-6.4-0.6c-10.6-1-20.6-6.7-26.9-15.3c0.4,9.6-6,18.1-12.3,25.4c-9.5,11.1-26.2,16.5-40.5,16.4
              c-12.5-0.1-24.9-4-35.7-10.3c-6.8-4-11.8-11.8-17.1-17.6c-3.9-4.2-5.9-7.7-8.3-12.7c-5.3,6.3-15,8.6-22.3,11.4
              c-9.7,3.7-19.4,7.4-29.1,11.1c-2.7,1.1-5.5,2.1-7.9,3.8c-2.4,1.7-4.3,4-6.2,6.3c-10.3,12.4-20.8,25.2-26.2,40.4
              c-4.5,12.8-5.1,26.7-5.6,40.3c-1.6,42.4-2.3,87.6,19.6,124c6.5,10.8,16.4,21.3,29,21.4c2.6,8.4,1.9,17.8-2.1,25.6
              c-3.3,6.6-8.8,12-12.2,18.5c-3.5,6.5-4.5,15.4,0.6,20.8c3.6,3.8,9.6,5.3,11.7,10c1.9,4.5-0.8,9.5-2.7,14
              c-1.9,4.5-2.6,10.8,1.6,13.3c1.4,0.9,3.2,1,4.8,1.2c16.3,1.6,32.6,2.6,48.9,3c8.3,0.2,16.6,0.2,24.9,0.3
              c6.8,0.1,12.7-2.4,19.5-4c35.3-8.2,72.3-1.7,108.2-6.6c4.1-0.6,9.8-2.7,12-6.4C664.5,695.1,664.6,694.9,664.7,694.7z"/>
            <path class="st6" d="M623.4,527.5c0.6,4.7,0.7,9.6,2.5,13.9c4.3-1.5,8.6-3.1,12.8-4.6c0.5-0.2,1.1-0.4,1.5-0.8
              c0.5-0.6,0.6-1.4,0.7-2.1c0.6-5.7,0.4-11.5-0.4-17.2c-0.2-1.4-0.4-2.7-1.1-3.9c-1-1.9-2.8-3.1-4.6-4.1c-1.7-1-3.6-1.7-5.5-2.4
              c-1.3-0.4-5.6-2.3-6.6-1.1c-0.4,0.5-0.4,1.2-0.5,1.8c-0.1,1.5,0,3.1,0.1,4.6c0.1,2.1,0.2,4.2,0.3,6.4
              C622.8,521.2,623,524.2,623.4,527.5z"/>
            <path class="st6" d="M478.3,511c0.5-1.9,1.3-3.6,2.6-4c1.9-0.7,3.9-1.4,5.8-2.2c2-0.7,4-1.5,6.2-1.7c2.1-0.2,4.4,0.3,6,1.7
              c1.6,1.5,2.3,3.7,2.8,5.8c0.7,2.7,1.3,5.5,1.8,8.3c-0.5-2.5-21.8,0.6-24.2,0.8C477.9,519.9,477.4,514.9,478.3,511z"/>
            <path class="st9" d="M666.8,610.6c-13.1,0-26.3,0.1-39.4,0.1c-12.4,0-24.9,0.1-37.3-0.5c-16.1-0.8-32.1-2.6-48-5.4
              c-7.4-1.3-16.7-3.1-23.6-6c-1.8-0.7-3.8-1.9-3.8-3.8"/>
            <path class="st9" d="M474.7,440.8c0.9,25.4,1.8,50.8,2.7,76.2c0,0.4,0.1,0.9,0.4,1.2c0.3,0.2,0.6,0.3,1,0.3
              c5.3,0.3,10.5,0.6,15.8,0.9c4.5,0.3,8.9,0.4,13.4-0.4c4.8-0.9,9.5-2.4,14.4-2.6c8-0.3,16,0,24-0.8c8.4-0.9,16.7-2.4,25-4
              c16.6-3.3,33.1-7.3,50-8.6c1.1,2.9,1.1,5.9,1.2,9c0.1,5.3,0,10.6,1.1,15.8c0.9,4.3,2.5,8.5,2.2,12.8"/>
            <path class="st9" d="M647.4,453.8c-2.4,16.7-4.7,33.4-5.9,50.3c-0.8,11.2-1.1,22.5-0.9,33.8c-19.2,0.7-37.2,11.6-53.6,21.5
              c-16.9,10.2-33.7,20.6-51.6,28.8c-18,8.2-37.2,14-57,14.5c-10.1,0.2-20.5-0.9-30.1,2.2"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <h5>{{ resultTitleKey | transloco }}</h5>
      <p>{{ resultTextKey | transloco }}</p>
    </div>
  }
</div>